import * as React from 'react';

import { cn } from '@/lib/utils';

/**
 * Native `<select>` wrapper — stessa palette/spacing di `Input` (no Radix
 * Select installato nel progetto; per un singolo dropdown un native select
 * accessibile è sufficiente e non introduce una nuova dipendenza).
 */
const Select = React.forwardRef<HTMLSelectElement, React.ComponentProps<'select'>>(
  ({ className, children, ...props }, ref) => {
    return (
      <select
        className={cn(
          'flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-base shadow-sm transition-colors placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 md:text-sm',
          className,
        )}
        ref={ref}
        {...props}
      >
        {children}
      </select>
    );
  },
);
Select.displayName = 'Select';

export { Select };
